import { SourceInterface } from 'src/api';

export type InterfaceType = 'bcc' | 'otbasy' | 'default' | 'market' | 'legal-entity' | 'cc';


export const getFieldList = (type: InterfaceType): SourceInterface['fieldList'] => {
    switch (type) {
        case 'bcc':
            return [
                {
                    key: 'text',
                    type: 'text',
                    isRequired: false,
                    multipleValues: true,
                    shouldExist: false,
                    labelEn: 'Attention! For a video call  a stable Internet connection, camera and microphone on your mobile device are required.',
                    labelKz: 'Бейнеқоңырау! Назар аударыңыз! Бейнеқоңырау жасау үшін тұрақты Интернет байланысы, мобильді құрылғыда камера мен микрофон болуы қажет.',
                    labelRu: 'Внимание! Для видеозвонка необходимо наличие стабильного Интернет подключения, камера и микрофон на мобильном устройстве.',
                },
                { key: 'lang', type: 'text', isRequired: false, settings: { value: 'ru' } },
                { key: 'name', type: 'text', isRequired: true, shouldExist: false, labelEn: 'Full Name', labelKz: 'Толық аты', labelRu: 'ФИО' },
                { key: 'iin', type: 'number', isRequired: true },
                { key: 'phone', type: 'tel', isRequired: true, labelEn: 'Phone', labelKz: 'Телефон', labelRu: 'Телефон' },
                {
                    key: 'text',
                    type: 'text',
                    isRequired: false,
                    multipleValues: true,
                    shouldExist: false,
                    labelRu: 'Нажимая на кнопку «Продолжить», Вы даёте согласие на:',
                    labelKz: '«Жалғастыру» түймесін басу арқылы сіз мыналармен келісесіз:',
                    labelEn: 'By clicking the "Continue" button, you agree to:',
                },
                {
                    key: 'agreement',
                    type: 'checkbox',
                    isRequired: true,
                    multipleValues: true,
                    settings: { link: '', linkKz: '', linkEn: '', agreementChecked: false },
                    labelRu: 'Сбор, обработку, хранение, передачу персональных данных и согласие на проведение видеозвонка с менеджером банка (уведомлен о записи видео разговора).',
                    labelKz: 'Жеке деректерді жинау, өңдеу, сақтау, беру және банк менеджерімен бейнебайланыс жүргізуге келісім беру (бейнеәңгімелесудің жазылуы туралы хабарланады).',
                    labelEn: 'Collection, processing, storage, transfer of personal data and consent to conduct a video call with a bank manager (notified of the recording of the video conversation).',
                },
                {
                    key: 'text',
                    type: 'text',
                    isRequired: false,
                    multipleValues: true,
                    shouldExist: false,
                    labelRu: 'А также ознакомлены и согласны с:',
                    labelKz: 'Біз сондай-ақ оқыдық және келісеміз:',
                    labelEn: 'And also familiar with and agree with:',
                },
                {
                    key: 'agreement',
                    type: 'checkbox',
                    isRequired: true,
                    multipleValues: true,
                    settings: {
                        link: 'https://vbank-web.bcc.kz/docs/standartnye-usloviia-predostavleniia-kompleksa-bankovskix-uslug-fiziceskim-licam-v-ao-bank-centrkred.html',
                        linkKz: 'https://vbank-web.bcc.kz/docs/standartnye-usloviia-predostavleniia-kompleksa-bankovskix-uslug-fiziceskim-licam-v-ao-bank-centrkred.html',
                        linkEn: 'https://vbank-web.bcc.kz/docs/standartnye-usloviia-predostavleniia-kompleksa-bankovskix-uslug-fiziceskim-licam-v-ao-bank-centrkred.html',
                        agreementChecked: false
                    },
                    labelRu: '«Договором на комплексное дистанционное банковское обслуживание физических лиц в АО «Банк ЦентрКредит»».',
                    labelKz: '«Банк ЦентрКредит» АҚ жеке тұлғаларға кешенді қашықтықтан банктік қызмет көрсетуге келісім',
                    labelEn: '"Agreement on comprehensive remote banking services for individuals in JSC Bank CenterCredit',
                },
                {
                    key: 'text',
                    type: 'text',
                    isRequired: false,
                    multipleValues: true,
                    shouldExist: false,
                    labelRu: 'и присоединяетесь к ним.',
                    labelKz: 'Біз сондай-ақ оқыдық және келісеміз:',
                    labelEn: 'and you join them.',
                },
            ];
        case 'otbasy':
            return [
                { key: 'lang', type: 'text', isRequired: false, settings: { value: 'kz' } },
                { key: 'phone', type: 'tel', isRequired: true },
                { key: 'iin', type: 'number', isRequired: true },
                { key: 'name', type: 'text', isRequired: true },
                { key: 'surname', type: 'text', isRequired: true },
                {
                    key: 'agreement',
                    type: 'checkbox',
                    isRequired: true,
                    multipleValues: true,
                    settings: { link: '', linkKz: '', linkEn: '', agreementChecked: false },
                    labelRu: 'Я даю своё согласие на сбор, обработку, хранение, передачу персональных данных третьим лицам и подтверждаю согласие на проведение видеозвонка с менеджером банка (уведомлен о записи видеоразговора).',
                    labelKz: 'Мен жеке деректерді жинауға, өңдеуге, сақтауға, үшінші тұлғаларға беруге келісімімді беремін және банк менеджерімен бейне қоңырауға келісімімді растаймын (маған бейнеәңгімелесудің жазылғаны туралы хабарланды).',
                    labelEn: 'I agree to the collection, processing, storage, and transfer of personal data to third parties and confirm my consent to a video call with a bank manager (I have been notified that the video conversation will be recorded).',
                },
            ];


        default:
            return [
                { key: 'lang', type: 'text', isRequired: false, settings: { value: 'ru' } },
                { key: 'phone', type: 'tel', isRequired: true },
                { key: 'iin', type: 'number', isRequired: true },
                { key: 'name', type: 'text', isRequired: true },
                { key: 'surname', type: 'text', isRequired: true },
            ];
    }
};
